import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { CarsState } from '../../types';

import { getADRClasses } from '../operations/getADRClasses';

import { STATUS_LOADING } from 'common/constants';

export const setADRClasses = (builder: ActionReducerMapBuilder<CarsState>) => builder
  .addCase(getADRClasses.pending, (state) => {
    state.adrClasses.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getADRClasses.fulfilled, (state, { payload }) => {
    state.adrClasses.loadingStatus = STATUS_LOADING.done;
    state.adrClasses.data = payload;
  })
  .addCase(getADRClasses.rejected, (state) => {
    state.adrClasses.loadingStatus = STATUS_LOADING.error;
  });